// TopNav or sidebar
export const GLOBAL = 'global';
// Tab navigation (e.g. inside a page)
export const CONTAINER = 'container';

export type NavigationLayer = typeof GLOBAL | typeof CONTAINER;
